/**
 * Created by juyang on 2017/9/14.
 *
 */
'use strict';
define(['../../base/Class','../../g2'], function (Class,g2) {
    function PointElement(coords, opt) {
        Class.setOptions(this, opt);
        this.coords = coords;
        this.options.geometry = this.getGeometry();
        g2.sfs.Element.call(this, this.options)

    }
    PointElement.prototype = {
        options: {},
        constructor: PointElement,
        getGeometry: function () {
            var objToString = Object.prototype.toString
            if (this.coords instanceof g2.sfs.Point)
                return this.coords
            else if (objToString.call(this.coords) === '[object Array]') {
                return new g2.sfs.Point({
                    x: this.coords[0],
                    y: this.coords[1],
                    spatialReference: this.options.spatialReference
                });
            }
            else if (objToString.call(this.coords) === '[object String]' && this.coords.indexOf('point') > -1) {

                return g2.sfs.GeometryFactory.createGeometryFromWkt(this.coords);

            }
            else if ((typeof this.coords === 'function' || (!!this.coords && typeof this.coords == 'object')) && this.coords.type == 'Point') {
                return g2.sfs.GeometryFactory.createGeometryFromGeoJson(this.coords);
            }
            else {
                console.error(('数据类型错误，只支持数组坐标、g2.sfs.Point、geojson、wkt'))
            }
        },
        envelope: function () {
            return this.getGeometry().envelope();
        },
        toString: function () {
            return this.getGeometry().asWkt();
        }
    }
    Class.inherits(PointElement, g2.sfs.Element);
    return PointElement;
})
